<template>
	<PageDefault>
		<br/>

		<h1>Статистика по областях</h1>
		<span>Тут представлений список областей та деяких міст. Що б отримати детальну статистику, натисніть на місто чи область, що вас зацікавила.</span>
		
		<br/><br/><br/>
	
		<div class="flex flex-row gap-2">
			<input 
				type="text" 
				v-model="searchText"
				placeholder="Пошук по назві..."
				class="text-box grow"
			>
			<div class="flex flex-row gap-2 shrink-0 [&>button>span]:hidden sm:[&>button>span]:block">
				<button 
					class="h-full" 
					@click="() => { sortType = 'name'; searchText = '' }"
				>
					<FontAwesomeIcon :icon="faArrowUpAZ" />
					<span>За назвою</span>
				</button>
				<button 
					class="h-full" 
					@click="() => { sortType = 'level'; searchText = '' }"
				>
					<FontAwesomeIcon :icon="faArrowUpWideShort" />
					<span>За забрудненням</span>
				</button>
			</div>
		</div>
	
		<br/>
		
		<div v-if="dataLoaded">
			<div class="flex flex-col gap-3">
				<RegionStatsItem 
					v-for="r in regionsList"
					:key=r.name
					:region=r
					@click="regionOnClick(r.name)"
					@keydown.space.prevent="regionOnClick(r.name)"
					@keydown.enter.prevent="regionOnClick(r.name)"
				/>
			</div>
			<div v-if="regionsList.length == 0" style="width: 100%; display: flex; justify-content: center;">
				<div>
					<br><br>
					Щось тут нічого нема...
					<br><br>
				</div>
			</div>
		</div>
		<div v-else class="flex flex-col gap-3">
			<SkeletonLoader 
				v-for="i in 24"
				:key="i"
				class="h-[121px] w-full rounded-xl" 
			/>
		</div>
		
		<br><br>
	</PageDefault>
</template>

<script setup>
import { ref, onMounted, watch, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useFuse } from '@vueuse/integrations/useFuse'

import RegionStatsItem from '@/components/RegionStatsItem.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faArrowUpAZ } from '@fortawesome/free-solid-svg-icons';
// import { faArrowUpZA } from '@fortawesome/free-solid-svg-icons';
import { faArrowUpWideShort } from '@fortawesome/free-solid-svg-icons';
// import { faArrowUpShortWide } from '@fortawesome/free-solid-svg-icons';

import { RegionsData } from '@/state/RegionsData.js'

import PageDefault from '@/components/ui/PageDefault.vue';
import SkeletonLoader from '@/components/ui/SkeletonLoader.vue';

const dataLoaded = ref(false)

const router = useRouter()

function regionOnClick(id) {
	router.push({ name: 'region', params: { id } })
}

const searchText = ref('')

const fuseOptions = {
	// isCaseSensitive: false,
	// includeScore: false,
	// shouldSort: true,
	// includeMatches: false,
	// findAllMatches: false,
	// minMatchCharLength: 1,
	// location: 0,
	// threshold: 0.6,
	// distance: 100,
	// useExtendedSearch: false,
	// ignoreLocation: false,
	// ignoreFieldNorm: false,
	// fieldNormWeight: 1,
	keys: [
		{ name: "name", weight: 2 },
		{ name: "name_qwerty", weight: 1 }
	]
};

const sortType = ref("level")
const sortReverse = ref(false)

function ukrainianToQwerty(text) {
	const qwerty = "qwertyuiop[]asdfghjkl;'zcvbnm,./'"
	const ukr =    "йцукенгшщзхїфівапролджєячсмитьбю."

	let result = "";

	for (const c of text) {
		if (ukr.includes(c)) {
			result += qwerty[ukr.indexOf(c)]
		} else {
			result += c
		}
	}

	return result
}

const regionsList = computed(() => {
	let list = RegionsData.get()

	if (list == null) return []

	list = list.map(e => ({ ...e, name_qwerty: ukrainianToQwerty(e.name) }))

	if (searchText.value != '') 
	{
		const { results: searchResults } = useFuse(searchText, list, { fuseOptions: fuseOptions })

		list = searchResults.value.map(e => e.item)
	} 
	else 
	{
		list = list.filter(e => e.online_stations > 0)

		list.sort((a, b)  => {
			if (sortType.value == "level") {
				return a.level - b.level
			} else {
				let nameA = a.name.toLowerCase();
				let nameB = b.name.toLowerCase();

				if (nameA > nameB) return -1
				else if (nameA < nameB) return 1
				else return 0
			}
		})

		if (!sortReverse.value) list.reverse()
	}

	return list
})

onMounted(() => {
	if (RegionsData.isUpdateNeeded()) {
		RegionsData.update()
		
		watch(RegionsData, () => {
			dataLoaded.value = RegionsData.get() != null
		})
	} else {
		dataLoaded.value = true
	}
})
</script>

<style scoped>

</style>